// extracted by mini-css-extract-plugin
export default {"bigTitleBox":"index_bigTitleBox_oXlqI","bigTitle":"index_bigTitle_PD-Lt","lengLeft":"index_lengLeft_F2jwe","lengRight":"index_lengRight_o7lsG"};